/* eslint-disable no-param-reassign */

import Immutable, { fromJS } from 'immutable';
import { NoteContent, Notes, NoteHistory } from '../../constants/actionTypes';

const initialState = {
  entities: {},
};

export default function (state = Immutable.fromJS(initialState), action) {
  switch (action.type) {
    // 获取文章内容
    case NoteContent.GET_NOTE_CONTENT: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], NoteContent.GET_NOTE_CONTENT);
      return state;
    }
    case NoteContent.GET_NOTE_CONTENT_SUCCESS: {
      const { noteId, data, isCache } = action;
      if (!isCache) {
        const { content, audio } = data;
        state = state.setIn(['entities', noteId, 'content'], content);
        state = state.setIn(['entities', noteId, 'audio'], fromJS(audio) || fromJS({}));
        // 内容的保存对用户来说十分的重要，所以这里单独用一个字段保存状态
        state = state.setIn(['entities', noteId.toString(), 'updateStatus'], Notes.UPDATE_NOTE_SUCCESS);
      }
      state = state.setIn(['entities', noteId.toString(), 'status'], NoteContent.GET_NOTE_CONTENT_SUCCESS);
      return state;
    }
    case NoteContent.GET_NOTE_CONTENT_FAIL: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], NoteContent.GET_NOTE_CONTENT_FAIL);
      return state;
    }
    // 更新文章内容ABBR和word num
    case NoteContent.UPDATE_NOTE_CONTENT_ABBR: {
      const { abbr, wordNum, noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'abbr'], abbr);
      state = state.setIn(['entities', noteId.toString(), 'wordNum'], wordNum);
      return state;
    }
    // 更新文章内容
    case Notes.UPDATE_NOTE: {
      const { noteId, content, title } = action;
      // 不管服务端，直接更新本地的数据
      state = state.setIn(['entities', noteId.toString(), 'content'], content);
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.UPDATE_NOTE);
      state = state.setIn(['entities', noteId.toString(), 'updateStatus'], Notes.UPDATE_NOTE);
      return state;
    }
    case Notes.UPDATE_NOTE_SUCCESS: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.UPDATE_NOTE_SUCCESS);
      state = state.setIn(['entities', noteId.toString(), 'updateStatus'], Notes.UPDATE_NOTE_SUCCESS);
      return state;
    }
    case Notes.UPDATE_NOTE_FAIL: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.UPDATE_NOTE_FAIL);
      state = state.setIn(['entities', noteId.toString(), 'updateStatus'], Notes.UPDATE_NOTE_FAIL);
      return state;
    }
    // 发布文章内容
    case Notes.PUBLISH_NOTE: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PUBLISH_NOTE);
      return state;
    }
    case Notes.PUBLISH_NOTE_SUCCESS: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PUBLISH_NOTE_SUCCESS);
      return state;
    }
    case Notes.PUBLISH_NOTE_FAIL: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'status'], Notes.PUBLISH_NOTE_FAIL);
      return state;
    }
    // 恢复版本,更新内容
    case NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS: {
      const { revertData: { title, content }, nbId, noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'content'], content);
      return state;
    }
    // 上传文章音频
    case NoteContent.POST_AUDIO: {
      const { noteId, audio } = action;
      state = state.setIn(['entities', noteId.toString(), 'audio'], fromJS(audio));
      return state;
    }
    // 上传文章音频名称与作者
    case NoteContent.PUT_AUDIO_MESSAGE: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.PUT_AUDIO_MESSAGE);
      return state;
    }
    case NoteContent.PUT_AUDIO_MESSAGE_SUCCESS: {
      const { noteId, data, params } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.PUT_AUDIO_MESSAGE_SUCCESS);
      state = state.setIn(['entities', noteId.toString(), 'audio', 'title'], params.title);
      state = state.setIn(['entities', noteId.toString(), 'audio', 'dubber'], params.dubber);
      return state;
    }
    case NoteContent.PUT_AUDIO_MESSAGE_FAIL: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.PUT_AUDIO_MESSAGE_FAIL);
      return state;
    }
    // 删除音频
    case NoteContent.DELETE_AUDIO: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.DELETE_AUDIO);
      return state;
    }
    case NoteContent.DELETE_AUDIO_SUCCESS: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.DELETE_AUDIO_SUCCESS);
      state = state.setIn(['entities', noteId.toString(), 'audio'], fromJS({}));
      return state;
    }
    case NoteContent.DELETE_AUDIO_FAIL: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.DELETE_AUDIO_FAIL);
      return state;
    }
    // 更新音频URL
    case NoteContent.GET_AUDIO_URL: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.GET_AUDIO_URL);
      return state;
    }
    case NoteContent.GET_AUDIO_URL_SUCCESS: {
      const { noteId, data } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.GET_AUDIO_URL_SUCCESS);
      state = state.setIn(['entities', noteId.toString(), 'audio', 'play_url'], data.play_url);
      return state;
    }
    case NoteContent.GET_AUDIO_URL_FAIL: {
      const { noteId } = action;
      state = state.setIn(['entities', noteId.toString(), 'audioStatus'], NoteContent.GET_AUDIO_URL_FAIL);
      return state;
    }
    default:
      return state;
  }
}

export const getState = state => state.NoteContent;



// WEBPACK FOOTER //
// ./src/reducers/NoteContent/NoteContentReducer.js